import React from 'react';
import XiLogo from './ui/XiLogo';
import { VoiceEnrollErrorBanner } from './VoiceEnrollStates';

/**
 * Voice enrollment — identity form step.
 *
 * Pure presentation: every field, value and handler comes from the caller.
 * Styling lives in `styles/xi-app.css` under `.xi-enroll` so both enrollment
 * flows (patient + staff) share one look and stay theme-aware.
 */
export default function VoiceEnrollForm({
  title,
  subtitle,
  formData,
  setFormData,
  fields,
  onSubmit,
  submitting,
  submitLabel,
  error = '',
}) {
  return (
    <div className="xi-public xi-enroll">
      <div className="xi-public__veil" aria-hidden="true" />
      <div className="xi-public__body">
        <div className="xi-enroll__brand">
          <XiLogo size="sm" tagline />
        </div>

        <div className="xi-auth-card xi-enroll__card">
          <header className="xi-auth-head">
            <span className="xi-eyebrow">Voice enrollment</span>
            <h1>{title}</h1>
            {subtitle ? <p>{subtitle}</p> : null}
          </header>

          <VoiceEnrollErrorBanner message={error} />

          <form
            className="xi-auth-form"
            onSubmit={(event) => {
              event.preventDefault();
              if (!submitting) onSubmit();
            }}
          >
            {fields.map((field) => (
              <div className="xi-field" key={field.name}>
                <label className="xi-label" htmlFor={`enroll-${field.name}`}>
                  {field.label}
                  {field.required ? <span aria-hidden="true"> *</span> : null}
                </label>
                {field.type === 'select' ? (
                  <select
                    id={`enroll-${field.name}`}
                    className="xi-select"
                    value={formData[field.name]}
                    required={field.required}
                    onChange={(event) =>
                      setFormData((prev) => ({ ...prev, [field.name]: event.target.value }))
                    }
                  >
                    {field.options.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={`enroll-${field.name}`}
                    className="xi-input"
                    type={field.type || 'text'}
                    value={formData[field.name]}
                    required={field.required}
                    placeholder={field.placeholder}
                    onChange={(event) =>
                      setFormData((prev) => ({ ...prev, [field.name]: event.target.value }))
                    }
                  />
                )}
              </div>
            ))}

            <button
              type="submit"
              className="xi-btn xi-btn--primary xi-btn--lg xi-btn--block"
              disabled={submitting}
            >
              {submitting ? 'Saving…' : submitLabel}
            </button>
          </form>

          <p className="xi-enroll__note">
            Your voice sample is used only to personalise your emotional assessment.
          </p>
        </div>
      </div>
    </div>
  );
}
